import {DataStatus} from 'platform/components';

import {useCallback} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetJbrConfigQuery, usePatchJbrConfigMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

export type FormValues = {
  subscriptionKey: string;
};

export function JbrSettings() {
  const {
    data: jbrQueryData,
    isLoading: isJbrQueryLoading,
    isError: isJbrQueryError,
    refetch: jbrQueryRefetch,
  } = useGetJbrConfigQuery();

  const [patchJbrMutation] = usePatchJbrConfigMutation();

  const handleSwitchChange = useCallback(
    (mutation: typeof patchJbrMutation, enabled: boolean, refetch?: typeof jbrQueryRefetch) => {
      mutation({
        jbrConfigRequestBody: {
          enabled,
          ...(!enabled && {credentials: null}),
        },
      })
        .unwrap()
        .then(() => {
          refetch?.();
        })
        .catch(handleApiError);
    },
    []
  );

  const items: SettingsStackItemProps[] = [
    {
      cyId: testIds.settings.jbr('link'),
      title: i18n.t('page.integrations.labels.jbrAuth'),
      url: settingsRoutes.jbrSettings,
      switchProps: {
        name: 'jbr-settings',
        // This condition was required by the original acceptance criteria
        // isDisabled: !jbrQueryData?.credentials?.subscriptionKey,
        isDisabled: false,
        value: jbrQueryData?.enabled ?? false,
        onChange: (enabled) => handleSwitchChange(patchJbrMutation, enabled, jbrQueryRefetch),
      },
    },
  ];

  return (
    <DataStatus
      isLoading={isJbrQueryLoading}
      isError={isJbrQueryError}
      isEmpty={isNilOrEmpty(items)}
      minHeight={50}
    >
      <SettingsStackItems items={items} />
    </DataStatus>
  );
}
